export const hasIdxUnit = (parameter) => {
    const parts = String(parameter).split(":");
    return parts[parts.length - 1] === "idx";
};
//# sourceMappingURL=ColorMapStepsRequest.js.map